export const ENV = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  PAYSTACK_PUBLIC_KEY: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
  PAYPAL_CLIENT_ID: process.env.REACT_APP_PAYPAL_CLIENT_ID,
  NODE_ENV: process.env.NODE_ENV,
};

export function requireEnv(name, value) {
  if (!value) {
    // In CRA, env vars are compile-time; this guard helps surface misconfig early.
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
}

export function getApiBaseUrl() {
  // Safe defaults for local dev; production should always set the env var.
  if (ENV.API_BASE_URL) return ENV.API_BASE_URL;
  if (ENV.NODE_ENV !== "production") return "http://localhost:2020";
  // Avoid silently deploying with a broken API config.
  // eslint-disable-next-line no-console
  console.warn(
    "REACT_APP_API_BASE_URL is not set. API calls will fail in production."
  );
  return "";
}

export function getSocketUrl() {
  if (ENV.SOCKET_URL) return ENV.SOCKET_URL;
  const apiBase = getApiBaseUrl();
  return apiBase || undefined;
}

